import { render, staticRenderFns } from "./TagOperationBlock.vue?vue&type=template&id=8a1ab284&scoped=true&"
import script from "./TagOperationBlock.vue?vue&type=script&lang=js&"
export * from "./TagOperationBlock.vue?vue&type=script&lang=js&"
import style0 from "./TagOperationBlock.vue?vue&type=style&index=0&id=8a1ab284&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1ab284",
  null
  
)

export default component.exports